import { useMemo } from "react";
import { PaginationResponse } from "../types/api.types";
import { InfiniteData } from "@tanstack/react-query";

export const useInfiniteQueryFlatted = <T>(
  data: InfiniteData<PaginationResponse<T>>
) => {
  return useMemo(() => {
    return data.pages.flatMap((page) => page.results);
  }, [data]);
};
